import * as actionTypes from '../actionTypes';
import initialState from './initialState';

function moversReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_APPOINTMENT_DATA:
      return { ...state, appointment: action.data };
    case actionTypes.UPDATE_CART_DATA:
      return {
        ...state,
        moveServiceInfo: action.data && action.data.moveServiceInfo ? action.data.moveServiceInfo : {},
        orderDetailsView: action.data && action.data.orderDetailsView ? action.data.orderDetailsView : {},
      };
    case actionTypes.UPDATE_ERROR_INFO:
      return { ...state, errorInfo: action.errorData };
    case actionTypes.UPDATE_SUSPEND_INFO:
      return { ...state, suspendInfo: action.suspendInfo };
    case actionTypes.UPDATE_ORDER_NUMBER:
      return { ...state, orderNo: action.orderNo };
    case actionTypes.UPDATE_DISCONNECT_DATE:
      return { ...state, appointment: action.data };
    case actionTypes.STORE_MOVERS_PLANS:
      return { ...state, plans: action.payload, getAvailablePlansError: '' };
    case actionTypes.STORE_MOVERS_ALL_PLANS_DETAILS:
      return { ...state, allPlansDetails: action.payload };
    case actionTypes.COMPARE_PLAN_API_STATUS:
      return { ...state, comparePlan: action.data };
    case actionTypes.GET_MOVER_PLANS_ERROR:
      return { ...state, getAvailablePlansError: action.payload };
    case actionTypes.STORE_MOVERS_NBS:
      return { ...state, estimatedBillSummary: action.payload };
    case actionTypes.STORE_MOVERS_IMPORTANT_ACCOUNT_CHANGES:
      return { ...state, importantAccountChanges: action.payload };
    case actionTypes.GET_AGREEMENT_DETAILS:
      return { ...state, agreement: action.data };
    case actionTypes.STORE_MTN:
      return { ...state, mtn: action.payload };

    default:
      return state;
  }
}

export default moversReducer;
